import React from 'react';
import { Box, Typography, Link, IconButton, Stack, useMediaQuery, useTheme } from '@mui/material';
import InstagramIcon from '@mui/icons-material/Instagram';
import { FaThreads } from 'react-icons/fa6';
import { FaTiktok } from 'react-icons/fa';
import TikTokIcon from '@mui/icons-material/MusicNote'; // No TikTok icon in MUI, using MusicNote as placeholder

const Footer = () => {

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm")); // Detect mobile
  const isTablet = useMediaQuery(theme.breakpoints.between("sm", "md")); // Detect tablet
  const isMediumDesktop = useMediaQuery("(min-width: 900px) and (max-width: 1450px)"); // Detect Tablet

  return (
    <Box className="main-footer" sx={{ bgcolor: '#E9E9E9', py: 5, px: 10, }} >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: isMobile ? 'center' : 'space-between',
          flexWrap: 'wrap',
        }}
      >
        <Box>
          <Typography variant="h6" sx={{ fontWeight: 'bold', color: '#1cb3b3', textAlign: isMobile ? "center" : "" }}>
            Sejiwa
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ textAlign: isMobile ? "center" : "" }}>
            2026 Sejiwa. All rights reserved.
          </Typography>
        </Box>

        <Box textAlign="center" sx={{ mt: isMobile ? 3 : 0 }}>
          <Typography variant="body2" sx={{ mb: 1 }}>
            Follow Us On
          </Typography>
          <Stack direction="row" spacing={0.5} justifyContent="flex-end">
            <IconButton
              aria-label="Threads"
              component={Link}
              href="#"
              target="_blank"
              rel="noopener"
              size="small"
            >
              <FaThreads style={{ fontSize: 20 }} />
            </IconButton>
            <IconButton
              aria-label="Instagram"
              component={Link}
              href="#"
              target="_blank"
              rel="noopener"
              size="small"
            >
              <InstagramIcon fontSize="medium" />
            </IconButton>
            <IconButton
              aria-label="TikTok"
              component={Link}
              href="#"
              target="_blank"
              rel="noopener"
              size="small"
            >
              <FaTiktok style={{ fontSize: 18 }} />
            </IconButton>
          </Stack>
        </Box>
      </Box>
    </Box>
  );
};

export default Footer;
